import { render, staticRenderFns } from "./SuggestionManage.vue?vue&type=template&id=86a349ba&scoped=true&"
import script from "./SuggestionManage.vue?vue&type=script&lang=js&"
export * from "./SuggestionManage.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionManage.vue?vue&type=style&index=0&id=86a349ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a349ba",
  null
  
)

export default component.exports